
    // this file was auto generated by python script
    import Columns from './Columns';
    export default Columns;
    